import React from "react";
import "../../assets/MOCK_OD/scss/modules/anim.scss";
import "../../assets/MOCK_OD/scss/modules/checklist.scss";
import "../../assets/MOCK_OD/scss/modules/personaldetails.scss";
import "../../assets/MOCK_OD/scss/modules/questionnaire.scss";
import "../../assets/MOCK_OD/scss/modules/accordian.scss";
import Footer from '../Includes/Layouts/MOCK_OD/Footer';
import GetVisitorsParams from "../../Utility/GetVisitorsParams";
import Questions from "../Includes/Layouts/MOCK_OD/Questions";
import QuestionsV2 from "../Includes/Layouts/MOCK_OD/QuestionsV2";

const CreditQuest_MOCK_OD = () => {
    return (
        <>
            <div className='MOCK_OD'>
                <GetVisitorsParams />
                <QuestionsV2/>
                <Footer />
            </div>
        </>
    )
}

export default CreditQuest_MOCK_OD;